module.exports = __webpack_public_path__ + "static/media/NajranBG.7b638b12.jpg";